import { default as doAskInfoModel } from './askInfoModel';
import { default as doReleaseModel } from './releaseModel';
import { default as doAnswerModel } from './answerModel';

export const sagaAskInfoModel = doAskInfoModel.sagas;
export const sagaReleaseModel = doReleaseModel.sagas;
export const sagaAnswerModel = doAnswerModel.sagas;
